import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'

const PageContainer = styled.div`
  max-width: 880px;
  margin: 0 auto;
  padding: ${SPACING.xxl} ${SPACING.lg};
  min-height: 100dvh;
`

const Header = styled.div`
  text-align: center;
  margin-bottom: ${SPACING.xxl};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.md};
`

const Table = styled.div`
  border: 1px solid var(--color-border);
  border-radius: ${BORDER_RADIUS.xl};
  overflow: hidden;
  background: var(--color-bg-secondary);
  margin-bottom: ${SPACING.xl};
`

const Row = styled.div<{ $highlight?: boolean }>`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  border-bottom: 1px solid var(--color-border);
  background: ${({ $highlight }) => ($highlight ? 'var(--color-bg-elevated)' : 'transparent')};

  &:last-child {
    border-bottom: none;
  }
`

const Cell = styled.div`
  padding: ${SPACING.sm} ${SPACING.md};
  display: flex;
  align-items: center;

  &:not(:first-child) {
    justify-content: center;
  }
`

const CTA = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACING.md};
  margin-top: ${SPACING.xl};
`

const FEATURE_ROWS = [55, 70, 45, 80, 60, 65, 50, 72]

export function SkeletonUpgrade() {
  return (
    <PageContainer>
      <Header>
        <SkeletonBox $width="260px" $height="36px" $radius={BORDER_RADIUS.lg} />
        <SkeletonBox $width="380px" $height="18px" $radius={BORDER_RADIUS.sm} />
      </Header>

      <Table>
        {/* Header row */}
        <Row $highlight>
          <Cell>
            <SkeletonBox $width="80px" $height="14px" $radius={BORDER_RADIUS.sm} />
          </Cell>
          <Cell>
            <SkeletonBox $width="40px" $height="14px" $radius={BORDER_RADIUS.sm} />
          </Cell>
          <Cell>
            <SkeletonBox $width="40px" $height="14px" $radius={BORDER_RADIUS.sm} />
          </Cell>
        </Row>
        {/* Price row */}
        <Row $highlight>
          <Cell>
            <SkeletonBox $width="60px" $height="13px" $radius={BORDER_RADIUS.sm} />
          </Cell>
          <Cell>
            <SkeletonBox $width="36px" $height="22px" $radius={BORDER_RADIUS.sm} />
          </Cell>
          <Cell>
            <SkeletonBox $width="72px" $height="22px" $radius={BORDER_RADIUS.sm} />
          </Cell>
        </Row>
        {/* Feature rows */}
        {FEATURE_ROWS.map((w, i) => (
          <Row key={i}>
            <Cell>
              <SkeletonBox $width={`${w}%`} $height="13px" $radius={BORDER_RADIUS.sm} />
            </Cell>
            <Cell>
              <SkeletonBox $width="20px" $height="13px" $radius={BORDER_RADIUS.sm} />
            </Cell>
            <Cell>
              <SkeletonBox $width="20px" $height="13px" $radius={BORDER_RADIUS.sm} />
            </Cell>
          </Row>
        ))}
      </Table>

      <CTA>
        <SkeletonBox $width="240px" $height="36px" $radius={BORDER_RADIUS.lg} />
        <SkeletonBox $width="100%" $height="52px" $radius={BORDER_RADIUS.xl} />
        <SkeletonBox $width="160px" $height="16px" $radius={BORDER_RADIUS.sm} />
      </CTA>
    </PageContainer>
  )
}
